import { Injectable, inject } from '@angular/core';
import { ModalOptions } from 'src/app/features/modal/modal.model';
import { ModalService } from 'src/app/features/modal/modal.service';
import { EmailResetModalComponent } from 'src/app/shared/modals/email-reset-modal/email-reset-modal.component';
import { IEmailResetModal, IEmailResetRequest } from 'src/app/shared/modals/email-reset-modal/email-reset-modal.model';

@Injectable({ providedIn: 'root' })
export class EmailResetHelper {
  private modalService = inject(ModalService);

  async triggerEmailResetModal(request: IEmailResetRequest): Promise<void> {
    const emailResetModal = {
      emailResetText: request.emailResetText,
      emailResetCodeText: request.emailResetCodeText,
      cardNumber: request.cardNumber,
      maskedPhoneNumber: request.maskedPhoneNumber,
      userEventSource: request.userEventSource,
      verifyCallback: request.verifyCallback.bind(this) as () => Promise<void>
    } as IEmailResetModal;

    return await this.modalService.openWithOnClose(new ModalOptions({ onCloseCallback: request.closeCallback }), EmailResetModalComponent, {
      content: emailResetModal
    });
  }
}
